<template>
    <div>
        <div class="wrap" :class="tabStyle ? 'tab-style' : ''">
            <div class="unit" :class="tabStyle ? 'tab-style' : ''">
                <span>{{ timeStr }}</span>
                <span>今日餐价</span>
                <span>(元/份)</span>
            </div>
            <div ref="content" class="unified-meal" :style="`animation-duration:${animationDuration}s`">
                <!-- 统缴餐 -->
                <div class="daily-type" :class="tabStyle ? 'tab-style' : ''">
                    <div class="daily-title" :class="tabStyle ? 'tab-style' : ''">统缴餐</div>
                    <div class="daily-tr daily-header" :class="tabStyle ? 'tab-style' : ''">
                        <div>名称</div>
                        <div>价格</div>
                        <div>指导价</div>
                        <div>比升降</div>
                    </div>
                    <div class="daily-tr daily-list" :class="tabStyle ? 'tab-style' : ''"
                        v-for="(subItem, subIndex) in tjcData" :key="subIndex">
                        <div>{{ subItem.name || '--' }}</div>
                        <div>{{ formatPrice(subItem.price) }}</div>
                        <div>{{ subItem.guidePrice || '--' }}</div>
                        <div class="img-wrap">
                            <img class="img" :src="renderArrow(subItem.compareIncreaseDecrease)">
                        </div>
                    </div>
                </div>

                <!-- 自选餐 -->
                <div class="daily-type" :class="tabStyle ? 'tab-style' : ''">
                    <div class="daily-title" :class="tabStyle ? 'tab-style' : ''">自选餐</div>
                    <div class="daily-tr daily-header" :class="tabStyle ? 'tab-style' : ''">
                        <div>名称</div>
                        <div>价格</div>
                        <div>指导价</div>
                        <div>比升降</div>
                    </div>
                    <div class="daily-tr daily-list" :class="tabStyle ? 'tab-style' : ''"
                        v-for="(subItem, subIndex) in zxcData" :key="subIndex">
                        <div>{{ subItem.name || '--' }}</div>
                        <div>{{ formatPrice(subItem.price) }}</div>
                        <div>{{ subItem.guidePrice || '--' }}</div>
                        <div class="img-wrap">
                            <img class="img" :src="renderArrow(subItem.compareIncreaseDecrease)">
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { handleTime, } from "@/assets/js/common";
export default {
    props: {
        deptId: {
            type: String,
            default: ''
        },
        outletsId: {
            type: String,
            default: ''
        },
        tabStyle: {
            type: Boolean,
            default: false,
        },
        tjcData: {
            type: Array,
            default: () => [],
        },
        zxcData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            iconArrUp: require("@/assets/images/icon_arrow_up.png"),
            iconArrDown: require("@/assets/images/icon_arrow_down.png"),
            iconArrNot: require("@/assets/images/icon_arrow_not.png"),
            timeStr: '',
            animationDuration: 0
        }
    },
    watch: {
        tjcData: function (newVal) {
            if (newVal && newVal.length > 0) {
                console.log('===> (item=10) 采购公示(【统缴餐】&自选餐) <===',
                    JSON.parse(JSON.stringify(this.tjcData)))
            }
        },
        zxcData: function (newVal) {
            if (newVal && newVal.length > 0) {
                console.log('===> (item=10) 采购公示(统缴餐&【自选餐】) <===',
                    JSON.parse(JSON.stringify(this.zxcData)))
                this.refreshPage()
            }
        }
    },
    computed: {},
    mounted() {
        this.initTimer()

        setTimeout(() => {
            this.refreshPage()
        }, 1000)
    },
    methods: {

        initTimer() {
            this.timeStr = `${handleTime()}`
        },

        refreshPage() {
            this.$nextTick(() => {
                this.calcDocumentHeight()
            })
        },

        renderArrow(value) {
            if (value === 'gt') {
                return this.iconArrUp
            }
            if (value === 'lt') {
                return this.iconArrDown
            }
            return this.iconArrNot
        },

        // 格式化价格，处理字符串和数字类型
        formatPrice(price) {
            if (price === null || price === undefined || price === '') {
                return '--'
            }
            const numPrice = typeof price === 'string' ? parseFloat(price) : Number(price)
            if (isNaN(numPrice)) {
                return '--'
            }
            return numPrice.toFixed(2)
        },

        // 计算高度
        calcDocumentHeight() {
            if (this.$refs.content.offsetHeight > 900) {
                this.animationDuration = (this.$refs.content.offsetHeight / 200) * 2.5
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes scroll-up {
    0% {
        transform: translateY(vh(80));
        /* 文本初始位置，向上偏移 0 */
    }

    100% {
        transform: translateY(-100%);
        /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
    }
}

$originFontColor: #3CEAFF;
$tabStyleFontColor: #A84E14;

.wrap {
    height: vh(766);
    width: 100%;
    overflow: hidden;

    &.tab-style {
        background: #efbcaf;
        background-size: 100% 100%;
    }

    .unit {
        position: absolute;
        left: 0;
        right: 0;
        top: vh(84);
        margin: auto;
        width: 90%;
        color: $originFontColor;
        font-size: vh(16);
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        >span:nth-of-type(1) {
            flex: 1;
            text-align: left;
        }

        >span:nth-of-type(2) {
            flex: 1;
            font-size: vh(20);
        }

        >span:nth-of-type(3) {
            flex: 1;
            text-align: right;
        }

        &.tab-style {
            color: #FFF;
        }
    }
}

.daily-type {
    @include font(22, #FFF, center);

    &.tab-style {
        color: $tabStyleFontColor;
    }

    .daily-title {
        color: $originFontColor;
        font-size: vh(32);
        margin: vh(40) auto vh(30);

        &.tab-style {
            color: $tabStyleFontColor;
        }
    }

    .daily-tr {
        display: flex;

        >div {
            flex: 1;
        }

        >div:first-of-type {
            text-align: left;
            padding-left: vh(40);
            white-space: break-spaces;
        }

        &.daily-header {
            background: url('../assets/images/daily_header_bg.png') 0 0 no-repeat;
            background-size: 100% 100%;
            color: $originFontColor;
            padding: vh(8) 0;

            &.tab-style {
                color: $tabStyleFontColor;
                background: #f3ae9a;
            }
        }

        &.daily-list {
            padding: vh(20) 0;
            border-bottom: 1px solid #01548E;

            &.tab-style {
                border-color: $tabStyleFontColor;
            }
        }
    }

    .img {
        width: vh(14);
    }
}

.unified-meal {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    animation-name: scroll-up;
    animation-duration: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>